import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-password-changed-success',
  templateUrl: './password-changed-success.component.html',
  styleUrls: ['./password-changed-success.component.scss']
})
export class PasswordChangedSuccessComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
    // Redirect automatico dopo 5 secondi
    setTimeout(() => {
      this.router.navigate(['/login']);
    }, 5000);
  }

  goToLogin() {
    this.router.navigate(['/login']);
  }
}